import { CSSProperties } from 'react';
import { styled } from 'styled-components';
import { Direction } from '../../../windows/helpers/adjustWindow';

interface LineProps {
  height?: number;
  width?: number;
  onMouseDown: (e: React.MouseEvent, dir: Direction) => void;
}

export const TopLine: React.FC<LineProps> = ({
  height = 10,
  width,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={topStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.Top)}
  />
);

export const RightLine: React.FC<LineProps> = ({
  height,
  width = 6,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={rightStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.Right)}
  />
);

export const BottomLine: React.FC<LineProps> = ({
  height = 8,
  width,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={bottomStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.Bottom)}
  />
);

export const LeftLine: React.FC<LineProps> = ({
  height,
  width = 6,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={leftStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.Left)}
  />
);

export const TopLeftLine: React.FC<LineProps> = ({
  height = 15,
  width = 15,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={topLeftStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.TopLeft)}
  />
);

export const TopRightLine: React.FC<LineProps> = ({
  height = 15,
  width = 15,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={topRightStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.TopRight)}
  />
);

export const BottomLeftLine: React.FC<LineProps> = ({
  height = 15,
  width = 15,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={bottomLeftStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.BottomLeft)}
  />
);

export const BottomRightLine: React.FC<LineProps> = ({
  height = 15,
  width = 15,
  onMouseDown,
}) => (
  <Line
    height={height}
    width={width}
    style={bottomRightStyles}
    onMouseDown={(e) => onMouseDown(e, Direction.BottomRight)}
  />
);

// #region styles
const diagonalStyles = {
  zIndex: 101,
  border: '3px solid transparent',
  borderRadius: '50%',
} as CSSProperties;

const topStyles = {
  top: '-5px',
  cursor: 'ns-resize',
} as CSSProperties;

const rightStyles = {
  top: 0,
  right: '-3px',
  cursor: 'col-resize',
} as CSSProperties;

const bottomStyles = {
  bottom: '-4px',
  cursor: 'ns-resize',
};
const leftStyles = {
  top: 0,
  left: 0,
  cursor: 'col-resize',
};
const topLeftStyles = {
  ...diagonalStyles,
  left: '-4px',
  top: '-4px',
  cursor: 'nwse-resize',
} as CSSProperties;

const topRightStyles = {
  ...diagonalStyles,
  right: '-4px',
  top: '-4px',
  cursor: 'nesw-resize',
};

const bottomLeftStyles = {
  ...diagonalStyles,
  left: '-4px',
  bottom: '-4px',
  cursor: 'nesw-resize',
};

const bottomRightStyles = {
  ...diagonalStyles,
  right: '-4px',
  bottom: '-4px',
  cursor: 'nwse-resize',
};

const Line = styled.div<{
  height?: number;
  width?: number;
}>`
  height: ${({ height }) => (height ? height + 'px' : '100%')};
  width: ${({ width }) => (width ? width + 'px' : '100%')};
  z-index: 100;
  background-color: transparent;
  position: absolute;
`;
// #endregion
